import { render, staticRenderFns } from "./footer1.vue?vue&type=template&id=bb61566e&scoped=true"
import script from "./footer1.vue?vue&type=script&lang=js"
export * from "./footer1.vue?vue&type=script&lang=js"
import style0 from "./footer1.vue?vue&type=style&index=0&id=bb61566e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb61566e",
  null
  
)

export default component.exports